<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >Transactions </h2>
        </div>
        <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a> 
        </div>
        <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='26'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="27">

            <label for="" class="mt-2" >Transactions are at the heart of any
                payment
                processing
                system,
                including payment gateways like PayG. In simple terms, a transaction is an
                exchange
                of
                value between a customer and your business, facilitated through the payment
                gateway.</label>
            <label for="" class="mt-2" >A transaction refers to the process
                of transferring
                funds
                from a
                customer's account to your business account as payment for goods or
                services.
                This
                process involves several steps to ensure that the payment is securely
                processed,
                authorized, and settled. </label>
        </div>
        <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="28">
            <h2 >Key Elements of a Transaction </h2>
            <ol>
                <li class="mt-3" ><b>Initiation:</b> &nbsp;A transaction
                    begins when a
                    customer
                    initiates
                    a payment for a product or service on your website or through another
                    channel.
                </li>

                <li class="mt-3" ><b>Authorization:</b> &nbsp;Once the
                    customer initiates the
                    payment,
                    the transaction data is securely transmitted to the payment gateway,
                    which
                    communicates with the customer's issuing bank or financial institution
                    to
                    seek
                    authorization for the payment. This step ensures that the customer has
                    sufficient
                    funds or credit to complete the transaction.</li>

                <li class="mt-3" ><b>Authentication:</b> &nbsp;Depending on
                    the security
                    measures
                    in
                    place, the customer might need to provide additional authentication,
                    such as
                    a
                    one-time password (OTP) or biometric verification, to confirm their
                    identity
                    and
                    approve the transaction. </li>
                <li class="mt-3" ><b>Processing: </b> &nbsp;After receiving
                    the authorization
                    and
                    authentication, the payment gateway processes the payment. It securely
                    transmits
                    the
                    payment details to the merchant's acquiring bank, which then transfers
                    the
                    funds
                    to
                    the merchant's account. </li>

                <li class="mt-3" ><b>Settlement:</b> &nbsp;The settled funds
                    are transferred
                    from
                    the
                    customer's account to your business account, typically within a few
                    business
                    days.
                    This step completes the transaction. </li>
                <li class="mt-3" ><b>Confirmation: </b> &nbsp;Both you, as
                    the merchant, and
                    the
                    customer
                    receive confirmation of the successful transaction. The customer usually
                    receives a
                    payment receipt, while you receive a notification of the payment and its
                    details.
                </li>
            </ol>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="29">
            <h2 >
                Security Measures
            </h2>
            <label for="" class="mt-2" >PayG implements various security
                measures, including
                encryption,
                tokenization, and fraud detection, to ensure that transactions are safe and
                protected
                from unauthorized access or data breaches.</label>
        </div>

        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
            (mouseout)="showpayment(false,'5')" id="30">
            <h2 >
                Importance of Reliable Transactions
            </h2>
            <label for="" class="mt-3" >Reliable and secure transactions are
                essential for
                building
                trust
                with your customers. By providing a seamless and secure payment experience,
                you
                enhance
                customer satisfaction and increase the likelihood of repeat business.
                Remember,
                PayG
                is
                here to facilitate these transactions efficiently and securely, allowing you
                to
                focus on
                growing your business while we handle the technical aspects of payment
                processing.
                If
                you have any questions or need assistance, our support team is always ready
                to
                help.
            </label>
        </div>
    </div>
</div>
</div>
<div class="col-md-4  hide-tbl content2  ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                Table of Contents:
            </h5>
           
        </div>
        <!-- <div class="col-md-12 mt-2">
           <a href="#26">  <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        PayG’s Transactions </span>
                </div>
            </div></a>
        </div> -->
        <div class="col-md-12 mt-2">
            <a href="#27">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            >
                            PayG’s Transactions </span>
                     
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#28">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >Key
                            elements
                        </span>
                  
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#29">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                            >Security
                            Measures </span>
                  
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#30">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                            >Importance
                            of
                            transactions </span>
                       
                    </div>
                </div>
            </a>
        </div>

    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
            <a [routerLink]="['/video-kyc']">       <button class="btn btn-color" (click)="menues('Video KYC')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Video KYC
            </button></a>
                   </div>
        <div class="col-md-4    ">
            <a [routerLink]="['/refunds']"> <button class="btn btn-color" (click)="menues('Refunds')" >Refunds
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
           
        </div>
    </div>
</div>
</div>

